import { render, staticRenderFns } from "./tasksTable.vue?vue&type=template&id=fa325ad0"
import script from "./tasksTable.vue?vue&type=script&lang=ts"
export * from "./tasksTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports